import { Button, Dropdown, Menu } from '@cognite/cogs.js';

type RuleActionsProps = {
  isDisabled: boolean;
  isToggling: boolean;
  canRun: boolean;
  onEdit: VoidFunction;
  onClone: VoidFunction;
  onDelete: VoidFunction;
  onRun: VoidFunction;
  onToggleDisable: VoidFunction;
};

export function RuleActions({
  isDisabled,
  isToggling,
  canRun,
  onEdit,
  onClone,
  onDelete,
  onRun,
  onToggleDisable,
}: RuleActionsProps) {
  const toggleLabel = isDisabled ? 'Enable rule' : 'Disable rule';
  return (
    <Dropdown
      content={
        <Menu>
          <Menu.Item
            onClick={onEdit}
            aria-label="Edit rule"
            icon="Edit"
            iconPlacement="left"
          >
            <span>Edit rule</span>
          </Menu.Item>
          <Menu.Item
            onClick={onClone}
            aria-label="Clone rule"
            icon="Copy"
            iconPlacement="left"
          >
            <span>Clone rule</span>
          </Menu.Item>
          {canRun && (
            <Menu.Item
              onClick={onRun}
              aria-label="Run rule"
              icon="Play"
              iconPlacement="left"
            >
              <span>Run rule</span>
            </Menu.Item>
          )}
          <Menu.Item
            onClick={onToggleDisable}
            aria-label={toggleLabel}
            icon={isDisabled ? 'EyeShow' : 'EyeHide'}
            iconPlacement="left"
            disabled={isToggling}
          >
            <span>{toggleLabel}</span>
          </Menu.Item>
          <Menu.Item
            onClick={onDelete}
            aria-label="Delete rule"
            icon="Delete"
            iconPlacement="left"
            destructive
          >
            <span>Delete rule</span>
          </Menu.Item>
        </Menu>
      }
    >
      <Button
        icon="EllipsisVertical"
        type="ghost"
        size="small"
        aria-label="Rule options"
      />
    </Dropdown>
  );
}
